import { createFileRoute } from "@tanstack/react-router"

import { DriveIntakePanel } from "@/pages/DriveIntakePanel"

export const Route = createFileRoute("/monitoring/intake")({
  component: DriveIntakePanel,
})
